module.exports = __webpack_public_path__ + "img/denmark-stomach-cancer-female.5cfe2e66.png";